import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {CentroLogistico} from '../model/centro-logistico.model';
import {ApiResponse} from "../../../interfaces/response.interface";
import {Center, Warehouse} from "../../portal-compras/pages/config/interfaces/config.interface";
import {HttpControllers} from "../../../utils/Class/HttpController";
import {DATA_SOURCE} from "../../../../environments/environment";
import {
  CentroAlmacen,
  CentroAlmacenMuelles,
  Chofer,
  DetallePallet, EmployedPurchacedBussines,
  IngresoMaterialesCabPendiente,
  Muelle,
  muelleAsigando, Traslado,
  UserCentrosData,
  UsuarioCentroAlmacen
} from '../model/model';
import {ConfiguracionGet, ConfiguracionPost} from "../model/configuracion-transferencias.model";
import {QueryParams} from 'src/app/interfaces/request.interface';

@Injectable({
  providedIn: 'root'
})
export class AsignacionCentroAlmacenService {
  centerList$: Observable<ApiResponse<Center[]>> = new HttpControllers(this.http)
    .read<Center[]>({
      datasource: DATA_SOURCE.DMAESTROS,
      path: `centro-logistico`,
    });

  constructor(private http: HttpClient) {
  }

  findWarehouseList(idCenter: number) {
    return new HttpControllers<Warehouse[]>(this.http)
      .read<Warehouse[]>({
        datasource: DATA_SOURCE.DMAESTROS,
        path: `almacen/byCentro/${idCenter}`
      })
  }

  saveAlmacenesOrigen(body: any) {
    return new HttpControllers<CentroLogistico[]>(this.http)
      .create<CentroLogistico[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen`
      })
  }

  saveAlmacenesDestino(body: any) {
    return new HttpControllers<ConfiguracionPost[]>(this.http)
      .create<ConfiguracionPost[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-destino`
      })
  }

  saveIngresoMaterial(body: any) {
    return new HttpControllers<any[]>(this.http)
      .create<IngresoMaterialesCabPendiente[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/ingreso-materiales-cab`
      })
  }

  saveMuelles(body: any) {
    return new HttpControllers<Muelle[]>(this.http)
      .create<Muelle[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/muelles`
      })
  };

  saveAsignacionMuelles(body: any) {
    return new HttpControllers<any[]>(this.http)
      .create<any[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-muelle`
      })
  }

  saveAsignacionUsuarios(body: any) {
    return new HttpControllers<UserCentrosData[]>(this.http)
      .create<UserCentrosData[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/usuario-centro-almacen`
      })
  }

  getCentrosAlmacenesOrigen() {
    return new HttpControllers<CentroLogistico[]>(this.http)
      .read<CentroLogistico[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen`
      })
  }

  getAllCentrosAlmacenes() {
    return new HttpControllers<CentroAlmacen[]>(this.http)
      .read<CentroAlmacen[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen/all`
      })
  }

  getConfiguracionesTransferencia() {
    return new HttpControllers<ConfiguracionGet[]>(this.http)
      .read<ConfiguracionGet[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-destino/all`
      })
  }

  getCapturaBarra(codigoBarra: string) {
    return new HttpControllers<DetallePallet[]>(this.http)
      .read<DetallePallet[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `etiquetas-sap/${codigoBarra}`
      })
  }

  getCapturaBarraByIdOrigen(codigoBarra: string, idCentroAlmacenOrigen: string ) {
    return new HttpControllers<DetallePallet[]>(this.http)
      .read<DetallePallet[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `etiquetas-sap/${idCentroAlmacenOrigen}/${codigoBarra}`
      })
  }

  getMuelles() {
    return new HttpControllers<Muelle[]>(this.http)
      .read<Muelle[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/muelles`
      })
  }

  getCentroAlmMuelles() {
    return new HttpControllers<CentroAlmacenMuelles[]>(this.http)
      .read<CentroAlmacenMuelles[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-muelle/grouped`
      })
  }

  getUsuaciosCentroData() {
    return new HttpControllers<UserCentrosData[]>(this.http)
      .read<UserCentrosData[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/usuario-centro-almacen/usuarioGroup`
      })
  }

  getUsuariosCentroDataByuser(iduser: string) {
    return new HttpControllers<UsuarioCentroAlmacen[]>(this.http)
      .read<UsuarioCentroAlmacen[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/usuario-centro-almacen/usuario/${iduser}`
      })
  }

  getDestinosByOrgen(idCentroAlmacenOrigen: number) {
    return new HttpControllers<ConfiguracionGet>(this.http)
      .read<ConfiguracionGet>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-destino/byOrigen/${idCentroAlmacenOrigen}`
      })
  }

  getMuelelByOrigen(idCentroAlmacenOrigen: number) {
    return new HttpControllers<muelleAsigando[]>(this.http)
      .read<muelleAsigando[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-muelle/centro-almacen/${idCentroAlmacenOrigen}`
      })
  }

  getTrasladosByUser(iduser: string) {
    return new HttpControllers<Traslado[]>(this.http)
      .read<Traslado[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/ingreso-materiales-cab/byUser/${iduser}`
      })
  }

  getTrasladosPaginadosByUser(iduser: string, page: number = 0, size: number = 10, estado?: string, query?: string) {
    const queryParams: QueryParams<any> = {};
    
    if (page !== null && page !== undefined) queryParams.page = page;
    if (size !== null && size !== undefined) queryParams.size = size;
    if (query !== null && query !== undefined) queryParams.query = query;
    if (estado !== null && estado !== undefined) queryParams.estado = estado;
    return new HttpControllers<any>(this.http)
      .read<any>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/ingreso-materiales-cab/byUser/${iduser}/paginado`,
        queryParams
      })
  }

  getEstadoPosibles() {
    return of([
       { codigo: "A", texto: "ACTIVO" },
       { codigo: "I", texto: "INACTIVO" }
    ]);
 }

  getAllPlaca() {
    return new HttpControllers(this.http)
     .read<EmployedPurchacedBussines[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `placas/`, ///traslados/usuario-centro-almacen/usuarioActive/search
      }); 
  } 
  
  getAllTransportista() {
    return new HttpControllers(this.http)
     .read<EmployedPurchacedBussines[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `placas/TRA`, ///traslados/usuario-centro-almacen/usuarioActive/search
      }); 
  }

  getAllChofer() {
    return new HttpControllers(this.http)
     .read<Chofer[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `choferes`, ///traslados/usuario-centro-almacen/usuarioActive/search
      }); 
  }

  searchEmpleadosActive(queryParams: QueryParams<any>) {
    console.log(queryParams);
    return new HttpControllers(this.http)
      .read<EmployedPurchacedBussines[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `traslados/usuario-centro-almacen/usuarioActive`, ///traslados/usuario-centro-almacen/usuarioActive/search
        queryParams: queryParams
      });
  }

  searchPlacasActive(queryParams: QueryParams<any>) {
    console.log(queryParams);
    return new HttpControllers(this.http)
     .read<EmployedPurchacedBussines[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `placas/search`, ///traslados/usuario-centro-almacen/usuarioActive/search
        queryParams: queryParams
      }); 
  }

   searchTransporistaActive(queryParams: QueryParams<any>) {
    console.log(queryParams);
    return new HttpControllers(this.http)
     .read<EmployedPurchacedBussines[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `placas/search/TRA`, ///traslados/usuario-centro-almacen/usuarioActive/search
        queryParams: queryParams
      }); 
  }

  searchChoferActive(queryParams: QueryParams<any>) {
    console.log(queryParams);
    return new HttpControllers(this.http)
     .read<Chofer[]>({
        datasource: DATA_SOURCE.LOGISTICA, // O el datasource correcto según tu backend usbeee
        path: `choferes/search`, ///traslados/usuario-centro-almacen/usuarioActive/search
        queryParams: queryParams
      }); 
  }

  deleteCentroAlmacenOrigen(id: string) {
    return new HttpControllers<any[]>(this.http)
      .delete<any[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen/${id}`
      })
  }

  deleteCentroAlmacenOrigenByCentro(idcentro: string) {
    return new HttpControllers<CentroLogistico[]>(this.http)
      .delete<CentroLogistico[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen/centro/${idcentro}`
      })
  }

  deleteCentroAlmacenDestino(id: string) {
    return new HttpControllers<any[]>(this.http)
      .delete<any[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-destino/${id}`
      })
  }

  deleteMuelle(id: string) {
    return new HttpControllers<any[]>(this.http)
      .delete<any[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/muelles/${id}`
      })
  }

  deleteAsigancionMuelle(id: string) {
    return new HttpControllers<any[]>(this.http)
      .delete<any[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-muelle/centro-almacen/${id}`
      })
  }

  deleteAsigacionUsuario(id: string) {
    return new HttpControllers<any[]>(this.http)
      .delete<any[]>({
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/usuario-centro-almacen/${id}`
      })
  }

  updateCentroAlmacenOrigen(body: any) {
    return new HttpControllers<CentroLogistico[]>(this.http)
      .update<CentroLogistico[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-origen/`
      })
  }

  updateCentroAlmacenDestino(body: any) {
    return new HttpControllers<any[]>(this.http)
      .update<any[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/centro-almacen-destino/`
      })
  }

  updateMuelle(body: any) {
    return new HttpControllers<Muelle[]>(this.http)
      .update<Muelle[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/muelles/`
      })
  }

  updateStatusTraslado(body: any) {
    return new HttpControllers<any[]>(this.http)
      .update<any[]>({
        body,
        datasource: DATA_SOURCE.LOGISTICA,
        path: `traslados/ingreso-materiales-cab/actualizaEstado/`
      })
  }

}
